import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint2 = 'v1/configurations';
const baseEndpoint = 'v1/stuck-jobs'

const StuckService = {

  getAppConfiguration( accessToken ) {
    if( accessToken ) return axios.get( 'v1/configuration/info', {
      headers: { Authorization: `Bearer ${accessToken}` }
    } );
    return axios
      .get( 'v1/configuration/info' )
  },

  getConfigurations( accessToken ) {
    if( accessToken ) return axios.get( baseEndpoint, {
      headers: { Authorization: `Bearer ${accessToken}` }
    } );
    return axios
      .get( baseEndpoint )
  },

  getConfiguration(id) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  getLogs( params ) {
    return axios
      .get( `${baseEndpoint}`, { params } )
  },

  relaunch( id ) {
    return axios
      .put( `${baseEndpoint}/${id}/relaunch`)
  },
  disrupted( id ) {
    return axios
      .put( `${baseEndpoint}/${id}/disrupted`)
  },
  delete( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}`)
  },
  updateIncms( id, data ) {
    return axios
      .get( `${baseEndpoint}/${id}/update`, data )
  },
};

export default StuckService;



// WEBPACK FOOTER //
// ./services/StuckService.js